
import { VueMarqueeSlider } from 'vue-marquee-slider'
import { Component, Mixins } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'
import DashboardNewsTickerFeature from '~/components/features/DashboardNewsTicker'
import { formatToUSDCurrency } from '~/lib/utils/format'
import { NEWS_TICKER_CLOSED } from '~/plugins/mixpanel/events'

@Component({
  name: 'NewsTicker',
  components: {
    VueMarqueeSlider,
    Icon
  }
})
export default class NewsTicker extends Mixins(DashboardNewsTickerFeature) {
  paused = false

  created() {
    this.$mixpanel.track('$experiment_started', {
      'Experiment name': 'Dashboard News Ticker',
      'Variant name': this.getDashboardNewsTickerFeatureVariant()
    })
  }

  get formatToUSDCurrency() {
    return formatToUSDCurrency
  }

  get dismissed() {
    return this.$accessor.ui.newsTickerDismissed
  }

  set dismissed(data) {
    this.$accessor.ui.setState({ stateName: 'newsTickerDismissed', data })
  }

  trackNewsTickerClose() {
    this.$mixpanel.track(NEWS_TICKER_CLOSED)
  }

  handleCloseButton() {
    this.dismissed = true
    this.trackNewsTickerClose()
  }
}
